import { App } from '@types';

const Settings = {
  speedTest() {
    // This may actually not be needed. Might be better to just always use preview images
    // and rely on filesize to override as needed. TBD. Leaving in here just in case for now but
    // hardcoded to always set to LOW.
    return false;
  },

  getBandwidthThreshold(): App['bandwidth'] {
    if (Settings.speedTest()) {
      return 'HIGH';
    }
    return 'LOW';
  },
};

export default Settings;
